import { LibraryBlockEditController } from '@features/library-block-edit';
import withMenuLayout from '@root/src/layout/withMenuLayout';

export const UserSingleBlockPage = withMenuLayout(LibraryBlockEditController);
